priceUpdate:
  title: Edit Yacht Price
  baseRate:
    title: Choose a Base Rate
    description: You will be able to customise the details of this rate in the next step.
  edit:
    changeBaseRate: Change Base Rate
notesUpdate:
  title: Edit Custom Note
  label: Custom Note
unpublished:
  title: This yacht is no longer available
  description: "{{ yachtName }}'s central agent has withdrawn it from the charter market."
